import React, { FC } from 'react'
import { cn } from '@/lib/utils'

const Logo: FC<{ width?: number; height?: number; className?: string }> = ({
  width = 40,
  height = 40,
  className = 'mb-3 ml-px mt-2',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 116.8 114"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className, 'fill-primary')}
    >
      <path d="m61.9 30.6c-6.9 0-14.6-5.6-14.6-14.6s7.7-14.9 14.5-14.9c7.7 0 14.9 6.1 14.9 14.9 0 8.4-6.8 14.6-14.8 14.6z" />
      <path d="m109.4 39.5c2-1.3 5.9-4.1 5.9-9.6 0.1-6-4.4-10.8-10.3-10.8-3.5-0.2-7.2 0.9-10.7 2.9l-26.2 15.5c-3.2 1.9-8.6 3.5-13.6-0.7l-32.8-29.9c-1.9-1.7-4.2-3.1-7.9-3.1-6 0-11.6 4.9-11.6 11.6 0 3.6 1.4 6.1 3.7 8.6l23.6 25c2.2 2 2.5 4.8 2.5 7.9s-1.2 7.6-8.1 12.1l-18.1 12.2c-1.5 1.2-4.3 4.1-4.3 8.7 0 5.4 4.1 11.4 10.9 11.4 3.4 0 5.7-1.1 7.3-2l28.9-17.4c2.6-1.5 4.8-2.2 7-2.1 2.8 0 4.8 0.5 7.8 2.6l31 27.2c2.3 1.9 4.7 3.3 8.2 3.3 5.8 0.2 11.2-4.5 11.3-10.9 0.1-3.9-1.4-6.4-2.7-7.8 0 0-14.7-16-22.1-23.2-2.1-2.1-4.4-4.9-4.3-8.5 0-3 1.6-6.5 4.3-8.7l20.3-14.3z" />
    </svg>
  )
}

export default Logo
